import React, { SVGProps } from 'react'
const SvgSearch = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M13.52 14.227a5.5 5.5 0 1 1 .707-.707l4.955 4.955a.5.5 0 0 1-.707.707l-4.955-4.955ZM10 14.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
    />
  </svg>
)
export default SvgSearch
